export default __webpack_public_path__ + "aec3c1f0e2b445641985eb9371d1e8cf.svg";